module.exports = __webpack_public_path__ + "img/loaderV3_darkMode_2.e4e1be9b.gif";